// extracted by mini-css-extract-plugin
export var brand = "_2z-7";
export var compact = "_2z-5";
export var extraSmall = "_2z-a";
export var icon = "_2z-0";
export var large = "_2z-3";
export var light = "_2z-1";
export var medium = "_2z-4";
export var outline = "_2z-9";
export var primaryDark = "_2z-8";
export var primaryLight = "_2z-6";
export var primaryModern = "_2z-b";
export var success = "_2z-2";